/*
 * 本番ビルド（GATSBY_STATS === 'production'）でだけ、gatsby-node.js の onCreateWebpackConfig が
 * `@contentful/live-preview/react` をこのファイルに差し替える（#750）。ライブプレビューは stg でしか使わず、
 * SDK は全ページの app チャンクに入るため。
 *
 * Provider を外すだけでは記事系テンプレートの useContentfulLiveUpdates が throw するので（#695）、
 * 使っている 3 つを「何もしない」形で揃えて差し替える。使う名前を増やしたら、ここにも足すこと
 * （tests/live-preview-stub/ が赤にする）。
 */

export const ContentfulLivePreviewProvider = ({ children }) => children

/* SDK はプレビュー中でなければ受け取ったデータをそのまま返す。 */
export const useContentfulLiveUpdates = (data) => data

/* SDK は Inspector が無効なとき、null を返す関数を返す（4.2.3 の src/react.tsx）。 */
export const useContentfulInspectorMode = () => () => null
